import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { RefContextLanguage } from '../providers/LanguageProvider';

function BackButton() {

    const navigate = useNavigate();

    return (
        <Button onClick={() => navigate(-1)}><ArrowLeftOutlined /></Button>
    )
}

export function BackButtonLarge() {

    const navigate = useNavigate();

    const i18n = RefContextLanguage();


    return (
        <Button style={{ marginTop: 10 }} onClick={() => navigate(-1)}>
            {i18n.t('goBack')}
        </Button>
    )
}

export default BackButton

